/**
 * Controls whether filter buttons are triggered by onMouseDown or onClick
 */ export var ENABLE_ON_MOUSE_DOWN_FOR_FILTER_BUTTONS_250122 = 'ENABLE_ON_MOUSE_DOWN_FOR_FILTER_BUTTONS_250122';
